module.exports = __webpack_public_path__ + "static/media/chm-bau32_4.97669485.gif";